export default {

    state: () => ({
        products: [],
    }),

    actions: {
        GET_PRODUCTS: async (context) => {
            fetch("/api/catalog/")
                .then(async response => await response.json())
                .then(resp => {
                    if(resp.success !== true)
                        alert(resp.message)
                    else
                    {
                        if(resp.data)
                        {
                            context.commit('SET_FAVS', resp.data);
                        }
                    }
                })
        },
        SET_PRODUCTS: (context, products) => {
            for(let key in products)
            {
                context.commit('SET_PRODUCT', products[key]);
            }
        },
    },

    mutations: {
        SET_PRODUCT: (state, product) => {
            state.products.push(product);
        },
    },

    getters: {}

}